import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// import AuthNavbar from "components/Navbars/AuthNavbar.js";
// import AuthFooter from "components/Footers/AuthFooter.js";
import Login from "../views/Pages/Login.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { authRoute } from "../routes.js";
import { resolveSessionLandingRoute } from "../utilities/landingRoute.js";

function Auth() {
  // The login URL can still be reached through browser history after a
  // successful sign-in. A valid session owns that URL too: replace it with the
  // account's dashboard instead of rendering a second login form.
  const landingRoute = resolveSessionLandingRoute();
  if (landingRoute) {
    return <Redirect to={landingRoute} />;
  }

  return (

    <div className="wrapper">
      <Sidebar
        routes={authRoute}
        image={require("assets/img/sidebar-3.jpg")}
        background="black"
      />
      <div className="main-panel">
        {/* <AuthNavbar /> */}
        <div className="content">
          <Switch>
            <Route path="/auth/login-page" component={Login} />
            {/* Add other auth routes here if needed */}
            <Redirect from="/auth" to="/auth/login-page" />
          </Switch>
        </div>
        {/* <AuthFooter /> */}
      </div>
    </div>
  );
}

export default Auth;
